import { render, staticRenderFns, recyclableRender, components } from "./application_status.vue?vue&type=template&id=45191bde&"
var renderjs
import script from "./application_status.vue?vue&type=script&lang=js&"
export * from "./application_status.vue?vue&type=script&lang=js&"
import style0 from "./application_status.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop/application_status.vue"
export default component.exports